export default __webpack_public_path__ + "static/media/refresh.cdf903d4.svg";